import { User } from "../models/user";
import { Authenticate } from "../models/authenticate";
import { Action } from "@ngrx/store";

export const LOGIN = '[Auth] Login';
export const LOGOUT = '[Auth] Logout';
export const LOGIN_SUCCESS = '[Auth] Login Success';
export const LOGIN_FAILURE = '[Auth] Login Failure';
export const LOGIN_REDIRECT = '[Auth] Login Redirect';

export const PWD_RESET = '[Auth] Password Reset';
export const PWD_RESET_SUCCESS = '[Auth] Password Reset Success';
export const PWD_RESET_FAILURE = '[Auth] Password Reset Failure';

export class Login implements Action {
  readonly type = LOGIN;

  constructor(public payload: {authenticate: Authenticate, returnUrl : string} ) { }
}

export class LoginSuccess implements Action {
  readonly type = LOGIN_SUCCESS;

  constructor(public payload: { user: User }) { }
}

export class LoginFailure implements Action {
  readonly type = LOGIN_FAILURE;

  constructor(public payload: { exception: string, isInvalidGrant:boolean}) { }
}

export class LoginRedirect implements Action {
  readonly type = LOGIN_REDIRECT;
  constructor(public payload: { returnUrl: string }) { }
}

export class Logout implements Action {
  readonly type = LOGOUT;

  constructor(public isInMyDashboardMode: boolean) {}
}

export class PasswordReset implements Action {
  readonly type = PWD_RESET;

  constructor(public email: string ) { }
}

export class PasswordResetSuccess implements Action {
  readonly type = PWD_RESET_SUCCESS;

  constructor(public message: string) { }
}

export class PasswordResetFailure implements Action {
  readonly type = PWD_RESET_FAILURE;

  constructor(public error: any) { }
}

export type Actions =
  | Login
  | LoginSuccess
  | LoginFailure
  | LoginRedirect
  | Logout
  | PasswordReset
  | PasswordResetSuccess
  | PasswordResetFailure;
